import React from 'react';
import { loadMeowContract } from '../util/StandardGetters'
import { renderLocaleTime, weiToMeow } from '../util/Utils'

export const requiredData = {
  name: 'stake',
  get: async (accounts) => {
    const {contract: meow} = await loadMeowContract(accounts);
    
    let currentlyStaked = meow.methods.currentlyStaked(accounts[0]).call()
    let unlockStartTime = meow.methods.unlockStartTime(accounts[0]).call();
    let balance = meow.methods.balanceOf(accounts[0]).call();

    [unlockStartTime, currentlyStaked, balance] = await Promise.all([unlockStartTime, currentlyStaked, balance]);

    return {
      meow, currentlyStaked, unlockStartTime, balance
    }
  }
}

const stakingRequirement = '10000000000000000';

function unlockedAt(unlockStart) {
  return unlockStart + (86400 * 5)
}

export default function Stake(props) {
  const { meow, unlockStartTime, currentlyStaked, balance } = props.stake;
  const from = props.accounts[0];
  const now = (Date.now() / 1000);
  const unlockStartNum = unlockStartTime.toNumber();
  const locked = unlockStartTime !== 0 && now < unlockedAt(unlockStartNum);

  let sufficientFunds = false;
  if (!currentlyStaked && !locked) {
    sufficientFunds = balance.gte(stakingRequirement)
  }

  const stakeWallet = () => meow.methods.stakeWallet().send({from});
  const unstakeWallet = () => meow.methods.unstakeWallet().send({from});

  return (
    <>
      <h1>
        This wallet is {currentlyStaked ? 'staked' : ' not staked'}
      </h1>
      <p>
        { currentlyStaked ?
          <span className='basic-button no-margin' onClick={unstakeWallet}>Unstake</span> :
          locked ?
            <>
              This wallet is locked from recently unstaking. It will be usable again at {renderLocaleTime(unlockedAt(unlockStartNum))}.
            </> :
            sufficientFunds ?
              <span className='basic-button no-margin' onClick={stakeWallet}>Stake</span> :
              <>
                {weiToMeow(stakingRequirement)} MEOW is required to stake
              </>
        }
      </p>
    </>
  )
}
